// import classnames from 'classnames';
// import React, { ReactNode } from 'react';

// import PlaceholderSvg from './images/sprite-placeholder.svg';

// export interface PureSvgProps {
//   className?: string;
//   type?: 'svg' | 'img';
//   src?: ReactNode;
//   width?: string | number;
//   height?: string | number;
//   restProps?: any;
// }
// const PureSvgIcon = (props: PureSvgProps) => {
//   const { className, type = 'svg', src = PlaceholderSvg, ...restProps } = props;
//   const cls = classnames('sprite-icon-components', { [`${className}`]: !!className, [`sprite-icon--${type}`]: !!type });
//   if (type === 'img') {
//     return <img src={src} className={cls} {...restProps} />;
//   }
//   return (
//     <svg className={cls} {...restProps} fill='currentColor' crossOrigin='anonymous'>
//       <use className='svg-icon-use' href={src} />
//     </svg>
//   );
// };


// export default PureSvgIcon;


import classnames from 'classnames';
import React, { ReactNode } from 'react';

import PlaceholderSvg from './images/sprite-placeholder.svg';

export interface PureSvgProps {
  className?: string;
  type?: 'svg' | 'img';
  src?: any;
  width?: string | number;
  height?: string | number;
  restProps?: any;
}

const PureSvgIcon = (props: PureSvgProps) => {
  const { className, type = 'svg', src = PlaceholderSvg, ...restProps } = props;
  
  const cls = classnames('sprite-icon-components', {
    [`${className}`]: !!className,
    [`sprite-icon--${type}`]: !!type
  });

  // =========================================================
  // 🔥 终极兼容逻辑 (基于你提供的日志分析)
  // =========================================================
  const getHref = (inputSrc: any) => {
    let source = inputSrc;

    // 1. 解包 ES Module 的 default (防止某些 loader 包装导致多一层)
    if (source && typeof source === 'object' && source.default) {
      source = source.default;
    }

    // 2. 处理对象 (关键分歧点)
    if (typeof source === 'object' && source !== null) {
      // 🟢 优先级 A: Webpack (Extract 模式)
      // 如果对象里包含 url 属性，说明生成了独立文件
      // 直接返回 url (例如: /hospital/assets/svgs/sprite.svg#sprite-tab-health)
      // 这一步最关键！之前忽略了 url 导致取到了错误的 id
      if (source.url) {
        return source.url;
      }

      // 🔵 优先级 B: Rsbuild (Inline 模式)
      // 如果没有 url，但有 id，说明是内联模式
      // 返回 #id (例如: #icon-sprite-tab-personal)
      if (source.id) {
        return `#${source.id}`;
      }
    }

    // 3. 处理字符串 (普通图片路径 或 纯 ID)
    if (typeof source === 'string') {
      // 如果包含路径特征，直接返回
      if (source.includes('/') || source.includes('.svg') || source.startsWith('#')) {
        return source;
      }
      // 否则补齐 #
      return `#${source}`;
    }

    return '';
  };

  const finalHref = getHref(src);

  if (type === 'img') {
    return <img src={finalHref} className={cls} {...restProps} />;
  }

  return (
    <svg className={cls} {...restProps} fill='currentColor' crossOrigin='anonymous'>
      <use className='svg-icon-use' href={finalHref} />
    </svg>
  );
};

export default PureSvgIcon;